import React, { useEffect, useState } from "react";
import { errorStatusHandle } from "../../utils/error-utils";
import { useDocumentTitle } from "../../hooks";
import { useDispatch } from "react-redux";
import { getApprovalSettingImportPage } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { APPROVAL_SETTING_MASTER_IMPORT } from "../../constants/routes";
import { importApprovalSettings } from "../../api/approvalSettingsApi";
import { API_GET_APPROVAL_SETTING_TEMPALTE } from "../../constants/api";
import BackendLayout from "../../layouts/BackendLayout";
import PageAlert from "../../components/alerts/PageAlert";
import {
  FileTemplateDownloader,
  FileUploader,
  PageTitle,
  RedirectAlert,
} from "../../components";
import {
  resetAlert,
  setImportFileAlertError,
  setAlertSuccess,
  setPageLoading,
  clearPageLoading,
  setButtonProcessing,
  clearButtonProcessing,
} from "../../store/actions";
import {APPROVAL_SETTING_MASTER_IMPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

function ApprovalSettingImportPage() {
  useRedirectPage(APPROVAL_SETTING_MASTER_IMPORT_PAGE);
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();

  const setApprovalSettingImportPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getApprovalSettingImportPage();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };

  useEffect(() => {
    setApprovalSettingImportPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const breadcrumb = getRouteBreadcrumb(APPROVAL_SETTING_MASTER_IMPORT);
  useDocumentTitle("承認設定マスタインポート - 点検王");

  const handleChangeFileChange = (file) => {
    setSelectedFile(file);
    dispatch(resetAlert());
  };

  const BUTTON_IMPORT_APPROVAL_SETTINGS = "button__import-approval-settings";
  const handleUpload = () => {
    dispatch(setButtonProcessing(BUTTON_IMPORT_APPROVAL_SETTINGS));
    dispatch(resetAlert());
    const formData = new FormData();
    formData.append("file", selectedFile);
    importApprovalSettings(formData)
      .then((response) => {
        dispatch(setAlertSuccess(response.message));
        setSelectedFile(null);
      })
      .catch((error) => {
        errorStatusHandle(error);
        if (error.status === 400) {
          let responseData = error.data.data;
          dispatch(setImportFileAlertError(responseData));
        }
      })
      .finally(() => {
        dispatch(clearButtonProcessing(BUTTON_IMPORT_APPROVAL_SETTINGS));
      });
  };

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="承認設定マスタインポート" />
      <RedirectAlert />
      <PageAlert />
      <div className="lg:flex mt-6 2xl:space-x-[32px] xl:space-x-[28px] lg:space-x-[24px] lg:space-y-0 md:space-y-[24px]">
        <FileUploader
          title="ファイルをアップロード"
          description="承認設定をインポートしたいファイルをアップロードしてください"
          file={selectedFile}
          handleUpload={handleUpload}
          handleChangeFileChange={handleChangeFileChange}
          buttonId={BUTTON_IMPORT_APPROVAL_SETTINGS}
        />
        <FileTemplateDownloader
          title="テンプレートファイル"
          description="テンプレートファイルを持っていない場合、インポートに使用するファイルをこちらからダウンロードしてください。"
          apiUrl={API_GET_APPROVAL_SETTING_TEMPALTE}
        />
      </div>
    </BackendLayout>
  );
}

export default ApprovalSettingImportPage;
